/**
 * Taf请求上下文类型定义
 */
export interface ITafContext {
  request: {
    moduleName: string;
    funcName: string;
    ReqClass: any;
    RspClass: any;
    data: any;
    timeoutMS?: number;
    useSendWupWithForceUa?: boolean;
    startTime?: number;
  };
  response: {
    data?: any;
    error?: any;
    duration?: number;
  };
  state: Record<string, any>;
}

export type TafMiddleware = (ctx: ITafContext, next: () => Promise<void>) => Promise<void>;

export class TafMiddlewareManager {
  private middlewares: TafMiddleware[] = [];

  use(middleware: TafMiddleware): this {
    this.middlewares.push(middleware);
    return this;
  }

  compose(ctx: ITafContext): (fn?: () => Promise<any>) => Promise<void> {
    return async (coreFunction?: () => Promise<any>) => {
      const dispatch = async (index: number): Promise<void> => {
        if (index >= this.middlewares.length) {
          if (coreFunction) {
            const result = await coreFunction();
            ctx.response.data = result;
          }
          return;
        }
        const middleware = this.middlewares[index];
        await middleware(ctx, () => dispatch(index + 1));
      };
      await dispatch(0);
    };
  }
}

export const tafMiddlewareManager = new TafMiddlewareManager();
